import { useQuery } from "@tanstack/react-query";
import type { OrderLinkFlowGetResponseType } from "@sellar-io/api-v2/types";
import {
  apiV2AssertResponse,
  apiV2Request,
  ApiV2QueryOptions,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderLinkFlowOrder = <TData = OrderLinkFlowGetResponseType,>(
  orderFlowToken: string | null,
  options?: ApiV2QueryOptions<TData>,
) => {
  return useQuery({
    queryKey: [ServerStateKeys.OrderLinkFlowOrder, orderFlowToken],
    queryFn: () =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "get",
        path: "order-link-flow/order",
        headers: {
          authorization: `Bearer ${orderFlowToken}`,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      user: undefined,
      business: null,
      overrideOptions: {
        enabled: Boolean(orderFlowToken),
        requireBusiness: false,
        requireUser: false,
        ...options,
      },
    }),
  });
};
